<template>
    <div class="py-4 bg-secondary">
    <div class="profile-page">
        <section class="section-new">
            <div class="container">
                <el-row>
                    <el-col :span="24">
                        <div class="card card-lift shadow border-0 card-address_page mb-3">
                            <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{$t('menu.pro_about')}}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{$t('submenu.staff')}}</el-breadcrumb-item>
                            </el-breadcrumb>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </section>
        <section class="section py-3 mb-3">
            <div class="container">
                <card shadow class="card_radius_no" no-body style="z-index: 10;">
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i>
                                <span class="kadr_title">{{$t('kadr.kadr_xizmat_title')}}</span>
                            </div>
                        </div>
                        <div class="mt-3 py-3 border-top text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-12">
                                    <p class="kadr_p" v-html="$t('kadr.kadr_prokura_title')"></p>
                                </div>
                                <div class="col-lg-12">
                                    <p class="kadr_p" v-html="$t('kadr.kadr_prokuratura')"></p>
                                </div>
                                <div class="col-lg-12">
                                    <p class="kadr_p" v-html="$t('kadr.kadr_prokuratura_text')"></p>
                                </div>
<!--                                <a href="#" class="card_div_link">-->
<!--                                    <span class="card_info_link">{{$t('app.bosh_pod')}}</span>-->
<!--                                    <img src="img/strategy/lex_logo.png" class="image_div_info_link">-->
<!--                                </a>-->
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName: '1'
            };
        }
    }
</script>
<style>
</style>
